import React, { useEffect, useState } from 'react';
import SellerIdentifyModal from './SellerIdentifyModal';
import { registerIdentityHost } from '../services/identityGate';

// Monté UNE fois à la racine (App.js) : c'est lui qui répond quand un écran
// appelle requestIdentity() (services/identityGate). Un seul endroit pour les
// deux coques (bureau MainLayout / mobile MobileLayout) : la fenêtre du CODE.
const IdentityGateHost = () => {
  const [ask, setAsk] = useState(null);

  useEffect(() => registerIdentityHost((request) => setAsk(request)), []);

  if (!ask) return null;
  const finish = (value) => {
    setAsk(null);
    ask.resolve(value);
  };

  return (
    <SellerIdentifyModal
      title={ask.options.title}
      reason={ask.options.reason}
      minLevel={ask.options.minLevel}
      onIdentified={(who) => finish(who)}
      onCancel={() => finish(false)}
    />
  );
};

export default IdentityGateHost;
